module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "560",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText))]), _vm._v(" "), (_vm.row && _vm.row.country) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("· " + _vm._s(_vm.row.country))]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "入职日 / 到期日"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row && _vm.row.hireDate) || '—') + " ~ " + _vm._s((_vm.row && _vm.row.probationEnd) || '—'))]), _vm._v(" "), (_vm.row && _vm.row.daysLeft != null) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("（" + _vm._s(_vm.daysLabel) + "）")]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评估结论",
      "required": ""
    }
  }, [_c('Radio-group', {
    model: {
      value: (_vm.form.result),
      callback: function($$v) {
        _vm.$set(_vm.form, "result", $$v)
      },
      expression: "form.result"
    }
  }, _vm._l((_vm.resultDict), function(item, code) {
    return _c('Radio', {
      key: code,
      attrs: {
        "label": code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), (_vm.form.result === 'EXTENDED') ? _c('Form-item', {
    attrs: {
      "label": "延长月数",
      "required": ""
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "max": 6,
      "step": 1
    },
    model: {
      value: (_vm.form.extendMonths),
      callback: function($$v) {
        _vm.$set(_vm.form, "extendMonths", $$v)
      },
      expression: "form.extendMonths"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("个月（1–6）")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.result === 'CONVERTED') ? _c('Form-item', {
    attrs: {
      "label": "新合同起止"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtBeginDate,
      "placeholder": "起始日",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.crtBeginDate = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("至")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtEndDate,
      "placeholder": "到期日",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.crtEndDate = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "muted"
  }, [_vm._v("可留空；填了会同时更新老师合同起止")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.result === 'TERMINATED') ? _c('Form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("只记录结论，不改老师状态；离职请到「老师管理」走现有离职流程")])], 1) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评估备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": "课堂表现、出勤、家长反馈等"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交结论")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-179333b8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/modal/ProbationDecideModal.vue
// module id = 1667
// module chunks = 8